import { motion } from "framer-motion";
import { useLanguage } from "../../i18n/LanguageContext";

export default function Hero() {
  const { t } = useLanguage();
  return (
    <section
      data-testid="hero-section"
      id="top"
      className="relative min-h-screen w-full overflow-hidden flex items-center"
    >
      <div className="absolute inset-0 bg-[#050505]" />
      <div
        className="absolute inset-0 opacity-[0.35]"
        style={{
          backgroundImage:
            "radial-gradient(ellipse at 70% 30%, rgba(197,160,89,0.18), transparent 55%), radial-gradient(ellipse at 20% 80%, rgba(197,160,89,0.10), transparent 60%)",
        }}
      />
      <div
        className="absolute inset-x-0 bottom-0 h-2/3 opacity-[0.06] pointer-events-none"
        style={{
          backgroundImage: "url('/logo.png')",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center 80%",
          backgroundSize: "min(1100px, 130%)",
          filter: "blur(2px)",
        }}
      />

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 pt-28 md:pt-24 pb-20 w-full">
        <motion.div
          initial={{ opacity: 0, scale: 0.92 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1.2, ease: "easeOut" }}
          className="flex flex-col items-center text-center mb-12 md:mb-16"
          data-testid="hero-logo-block"
        >
          <img
            src="/logo.png"
            alt="Trois Couronnes Productions"
            className="h-40 md:h-56 lg:h-64 w-auto object-contain"
          />
        </motion.div>

        <motion.h1
          initial={{ opacity: 0, y: 32 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.1, delay: 0.15, ease: "easeOut" }}
          className="font-display text-[#F5F5F0] text-4xl sm:text-5xl md:text-7xl lg:text-[88px] leading-[1.04] max-w-5xl"
          data-testid="hero-title"
        >
          <span>{t.hero.titleLine1}</span>{" "}
          <span className="block">
            <em className="text-[#C5A059] font-normal">
              {t.hero.titleAccent}
            </em>{" "}
            {t.hero.titleTail}
          </span>
        </motion.h1>

        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.7, ease: "easeOut" }}
          className="mt-14 flex flex-wrap items-center gap-6"
        >
          <a
            href="#catalogue"
            data-testid="hero-cta-catalogue"
            onClick={(e) => {
              e.preventDefault();
              document
                .getElementById("catalogue")
                ?.scrollIntoView({ behavior: "smooth" });
            }}
            className="inline-flex items-center gap-3 border border-[#C5A059] text-[#C5A059] hover:bg-[#C5A059] hover:text-[#050505] transition-all duration-300 px-7 py-4 text-[12px] tracking-[0.32em] uppercase"
          >
            {t.hero.ctaCatalogue}
            <svg width="18" height="10" viewBox="0 0 18 10" fill="none" aria-hidden>
              <path d="M0 5h16M12 1l4 4-4 4" stroke="currentColor" strokeWidth="1.2" />
            </svg>
          </a>
        </motion.div>
      </div>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.5, duration: 1 }}
        className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-3"
      >
        <span className="text-[10px] tracking-[0.4em] uppercase text-[#9c9b94]">
          {t.hero.scroll}
        </span>
        <span className="block h-12 w-px bg-gradient-to-b from-[#C5A059] to-transparent" />
      </motion.div>
    </section>
  );
}
